import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ComponentType } from "react";
import { WithRouterProps } from "./types";

export const withRouter = <Props extends WithRouterProps>(
  Component: ComponentType<Props>,
) => {
  return (props: Omit<Props, keyof WithRouterProps>) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();

    return (
      <Component
        {...(props as Props)}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  };
};
